var _a;

import { useEffect, useLayoutEffect as _useLayoutEffect } from 'react';
export var useLayoutEffect = typeof window !== 'undefined' // @ts-expect-error `window` is not available in SSR
&& ((_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.createElement) ? _useLayoutEffect : useEffect;